import script from "./ageDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ageDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ageDetailModal.vue?vue&type=style&index=0&id=530171e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530171e7"]])

export default __exports__